import React from 'react';
import Pagination from 'react-bootstrap/Pagination';
import { useDispatch } from 'react-redux';

function PaginationComponent({ currentPage, totalPages, fetchData, searchKeyword, role, onPageChange }) {
  const dispatch = useDispatch();
  const itemsPerPage = 15;

  const handlePageChange = (pageNum) => {
    if (role === 'SUPPORT') {
      dispatch(fetchData({ page: pageNum, limit: itemsPerPage, keyword: searchKeyword, role }));
    }
    if (onPageChange) {
      onPageChange(pageNum);
    }
  };

  const calculateVisiblePages = () => {
    const visiblePages = [];
    const maxVisiblePages = 5;

    visiblePages.push(1);
    let startPage = Math.max(2, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 2);
    if (endPage - startPage < maxVisiblePages - 2) {
      startPage = Math.max(2, endPage - maxVisiblePages + 2);
    }
    for (let i = startPage; i <= endPage; i++) visiblePages.push(i);
    return visiblePages;
  };

  return (
    <div className="d-flex justify-content-between mt-4 p-2">
      <Pagination>
        <Pagination.Prev
          disabled={currentPage === 1}
          onClick={() => handlePageChange(currentPage - 1)}
        />
        {calculateVisiblePages().map((num, index) => (
          <React.Fragment key={num}>
            {index === 1 && num !== 2 && <Pagination.Ellipsis />}
            <Pagination.Item
              active={num === currentPage}
              onClick={() => handlePageChange(num)}
            >
              {num}
            </Pagination.Item>
          </React.Fragment>
        ))}
        <Pagination.Next
          disabled={currentPage === totalPages}
          onClick={() => handlePageChange(currentPage + 1)}
        />
      </Pagination>
    </div>
  );
}

export default PaginationComponent;
